// routes.js

import LandingPage2 from '../components/landing-page-2/LandingPage2.svelte';
import PostalResultsPage from '../pages/public/PostalResultsPage.svelte';
import ResourceExplorerPage from '../pages/public/ResourceExplorerPage.svelte';

import HomePage from '../pages/auth/HomePage.svelte';
import SearchPage from '../pages/auth/SearchPage.svelte';
import ReviewPage from '../pages/auth/ReviewPage.svelte';

import MyResourcesPage from '../pages/auth/MyResourcesPage.svelte';
import MySearchesPage from '../pages/auth/MySearchesPage.svelte';
import MyReferralsPage from '../pages/auth/MyReferralsPage.svelte';
import MyPartnersPage from '../pages/auth/MyPartnersPage.svelte';

import ReferralsPage from '../pages/auth/ReferralsPage.svelte';
import ReferralUpdatePage from '../pages/auth/ReferralUpdatePage.svelte';
import PartnerOrgSettingsPage from '../pages/auth/PartnerOrgSettingsPage.svelte';

import ServiceCreatePage from '../pages/auth/ServiceCreatePage.svelte';
// import ServiceReadPage from '../pages/auth/ServiceReadPage.svelte';
import ServiceUpdatePage from '../pages/auth/ServiceUpdatePage.svelte';

import HelpPage from '../pages/public/HelpPage.svelte';
import AboutPage from '../pages/public/AboutPage.svelte';
import TermsPage from '../pages/public/TermsPage.svelte';
import PrivacyPage from '../pages/public/PrivacyPage.svelte';
import NotFoundPage from '../pages/public/NotFoundPage.svelte';

// 11/2 - need to integrate these into Azure flow
import LoginPage from '../pages/public/LoginPage.svelte';
import RegisterPage from '../pages/public/RegisterPage.svelte';

// why were these here - Vito?
// import { AccountStore } from "./account.ts";
// import { get } from 'svelte/store';


// each route maps to a "Page" component
const routes = {

    '/': LandingPage2,
    '/landing': LandingPage2,

    '/postal-results': PostalResultsPage,
    '/explorer': ResourceExplorerPage,
    
    '/home': HomePage,
    '/auth': HomePage,
    '/search': SearchPage,
    '/reviews': ReviewPage,
    '/create_service': ServiceCreatePage,

    // '/details/:id': ServiceReadPage,
    '/update/:id': ServiceUpdatePage,
    
    '/my-resources': MyResourcesPage,
    '/my-searches': MySearchesPage,
    '/my-referrals': MyReferralsPage,
    '/my-partners': MyPartnersPage,

    '/referrals': ReferralsPage,
    '/referral-update/:id': ReferralUpdatePage,
    '/partner_settings': PartnerOrgSettingsPage,

    // 06-23 TODO: new from Mike's mockups
    '/help': HelpPage,
    '/about': AboutPage,
    '/terms': TermsPage,
    '/privacy': PrivacyPage,

    // 11/2 - need to integrate these into Azure flow
    '/login': LoginPage,
    '/register': RegisterPage,

    // Catch-all is optional, but if present it must be the last
    '*': NotFoundPage
    
}

export default routes;
